import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import dayjs from 'dayjs';
import 'dayjs/locale/es';

dayjs.locale('es');

import { store, persistor } from '@/store/store';
import { NotificationProvider } from './context';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import { Router } from '@/routes/Router';

const App = () => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='es'>
          <NotificationProvider>
            {/* La app vive bajo /uy o /pe: el router tiene que conocer ese
                prefijo o toda navegacion interna apunta a la raiz del dominio.
                BASE_URL lo inyecta Vite desde `base` (ver vite.config.ts). */}
            <BrowserRouter
              basename={import.meta.env.BASE_URL}
              future={{
                v7_startTransition: true,
                v7_relativeSplatPath: true,
              }}
            >
              <Router />
            </BrowserRouter>
          </NotificationProvider>
        </LocalizationProvider>
      </PersistGate>
    </Provider>
  );
};

export default App;
